import { render, staticRenderFns } from "./modal-create.vue?vue&type=template&id=1595537e"
import script from "./modal-create.vue?vue&type=script&lang=js"
export * from "./modal-create.vue?vue&type=script&lang=js"
import style0 from "./modal-create.vue?vue&type=style&index=0&id=1595537e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports